import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
    },
}));

export default function STATSSAAreaCodeSearchForm(props) {
    const [labelWidth, setLabelWidth] = React.useState(0);
    const labelRef = React.useRef(null);
    const classes = useStyles();

    React.useEffect(() => {
        if (labelRef.current !== null) {
            setLabelWidth(labelRef.current.offsetWidth);
        }
    }, []);

    return (
        <div className={classes.container}>
            <table cellPadding="2">
                <tbody>
                    <tr>
                        <td>
                            <FormControl className={classes.formControl} variant="outlined">
                                <InputLabel ref={labelRef} htmlFor="Description">
                                    Description
                                </InputLabel>
                                <OutlinedInput
                                    id="Description"
                                    onChange={(ev) => props.model.Description = ev.target.value}
                                    labelWidth={labelWidth}
                                    onKeyPress={props.onKeyUp}
                                />
                            </FormControl>
                        </td>
                        <td>
                            <FormControl className={classes.formControl} variant="outlined">
                                <InputLabel ref={labelRef} htmlFor="AreaCode">
                                    STATSSA Area Code
								</InputLabel>
                                <OutlinedInput
                                    id="AreaCode"
                                    onChange={(ev) => props.model.SchoolEMIS = ev.target.value}
                                    labelWidth={labelWidth}
                                    onKeyPress={props.onKeyUp}
                                />
                            </FormControl>                   
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
